module.exports = __webpack_public_path__ + "1295be615dbbc96c2264cead72a913bf.pdf";